// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, makeStyles } from '@material-ui/core';

import { ClassroomDrawer } from 'Components/Classroom/Components';
import { Box, Flex, SvgIcon, Text } from 'Components/Base';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';
import QuizQuestion from 'Components/Quiz/Components/QuizQuestion';

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 540,
    borderLeft: 'none',
    backgroundColor: '#FAFAFA',
  },
  paperAnchorBottom: {
    height: '100%',
    backgroundColor: '#FAFAFA',
  },
}));

const SPACING_PADDING = 12;

function FlexWrapper({ topOffset, ...restProps }) {
  return (
    <Flex
      top={0}
      zIndex={1}
      paddingLeft={6}
      paddingRight={2}
      paddingTop={topOffset > 0 ? topOffset + SPACING_PADDING : SPACING_PADDING}
      paddingBottom={SPACING_PADDING}
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      style={{ boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)', borderBottom: '1px solid #D8D8D8' }}
      {...restProps}
    />
  );
}

function PassagePanel({ openDrawer, onCloseDrawer, isHorizontalDrawer, passage, layoutType }) {
  const { topOffset } = useOffset();
  const classes = useStyles();

  return (
    <ClassroomDrawer
      drawerProps={{
        open: openDrawer,
        horizontalAnchor: ClassroomDrawer.ANCHOR_TYPES.RIGHT,
        horizontal: isHorizontalDrawer,
        classes: {
          paperAnchorRight: classes.drawerPaper,
          paperAnchorBottom: classes.paperAnchorBottom,
        },
      }}
      styleWrapperChildrenProps={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
    >
      <>
        <FlexWrapper topOffset={topOffset}>
          <Text textStyle="heading5">{`บทความประกอบข้อ ${passage.questionNo}`}</Text>
          <IconButton onClick={onCloseDrawer}>
            <SvgIcon icon={SvgIcon.ICON_LIST.CLOSE} size={!isHorizontalDrawer ? 24 : 26} />
          </IconButton>
        </FlexWrapper>
        <Box overflow="auto" flexGrow={1} padding={6}>
          <QuizQuestion question={passage.title} />
        </Box>
      </>
    </ClassroomDrawer>
  );
}

FlexWrapper.propTypes = { topOffset: PropTypes.number };

PassagePanel.propTypes = {
  openDrawer: PropTypes.bool,
  onCloseDrawer: PropTypes.func,
  isHorizontalDrawer: PropTypes.bool,
  toggleComponent: PropTypes.element,
  passage: PropTypes.shape({
    title: PropTypes.string,
    questionNo: PropTypes.string,
  }),
  layoutType: PropTypes.string,
};

export default PassagePanel;
